import { render, staticRenderFns } from "./ManagePermissions.vue?vue&type=template&id=26a21f2a&scoped=true"
import script from "./ManagePermissions.vue?vue&type=script&lang=js"
export * from "./ManagePermissions.vue?vue&type=script&lang=js"
import style0 from "./ManagePermissions.vue?vue&type=style&index=0&id=26a21f2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a21f2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a21f2a')) {
      api.createRecord('26a21f2a', component.options)
    } else {
      api.reload('26a21f2a', component.options)
    }
    module.hot.accept("./ManagePermissions.vue?vue&type=template&id=26a21f2a&scoped=true", function () {
      api.rerender('26a21f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ManagePermissions.vue"
export default component.exports